export default function () {
  return {
    errors: {},
    validFromMenu: false,
    validUntilMenu: false,
    formattedValidFrom: null,
    formattedValidUntil: null,
    coupon: {
      code: '',
      type: 0,
      enabled: true,
      validFrom: null,
      validUntil: null,
      students: [],
      maxUsage: 0,
      firstPurchaseOnly: false,
      usesPerUser: 0,
    },
    studentsList: [],
    loadingStudents: false,
    studentSearchQuery: '',
  }
}
